import React, { useState } from "react";
import "../auth.scss";
import { LogoImg, loginScreen } from "assets/images";
import Union from "assets/images/Union.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Input } from "common/InputForm";
import commonMessages from "utils/commonMessage";
import useButtonLoader from "common/UseButtonLoader";
import { resetPasswordApi } from "services/auth";
import { toastMessage } from "utils/toastMessage";
import usePasswordToggle from "common/UsePasswordToggle";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import { regex } from "utils/formValidator";
import OTPInput from "react-otp-input";
import { IoIosArrowBack } from "react-icons/io";

const ResetPassword = ({ data, setSteps, setData }) => {
  console.log(data, "datareset");
  const { passwordRegex } = regex;
  const [password, setPassword] = useState({});
  const [otp, setOtp] = useState("");

  const [inputType, icon] = usePasswordToggle();
  const [errors, setErrors] = useState({});
  const { VALID_PASSWORD, SAME_PASSWORD } = commonMessages;
  const [buttonLoader, setButtonLoader] = useButtonLoader("Reset");
  const { token } = useParams();
  const navigate = useNavigate();
  const [inputToggle, setInputToggle] = useState({
    newPassword: true,
    confirmPassword: true,
  });
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setPassword({ ...password, [name]: value });
  };

  // *---------------Validation------------*//
  const validation = () => {
    let status = true;
    const error = {};
    if (!password.newPassword) {
      error["newPassword"] = "Please enter your new password";
      status = false;
    } else if (!password.newPassword.match(passwordRegex)) {
      error["newPassword"] = VALID_PASSWORD;
      error["newPasswordErr"] = true;
      status = false;
    }
    if (!password.confirmPassword) {
      error["confirmPassword"] = "Please enter your confirm password";
      status = false;
    } else if (!password.confirmPassword.match(passwordRegex)) {
      error["confirmPassword"] = VALID_PASSWORD;
      error["confirmPasswordErr"] = true;
      status = false;
    }
    if (password.confirmPassword && password.newPassword) {
      if (password.confirmPassword !== password.newPassword) {
        error["confirmPassword"] = SAME_PASSWORD;
        error["confirmPasswordErr"] = true;
        status = false;
      }
    }
    if (!otp) {
      error["otp"] = "Please enter Otp";
      status = false;
    }
    setErrors(error);
    return status;
  };
  const toggleInputTypeHandler = (id) => {
    setInputToggle({ ...inputToggle, [id]: !inputToggle[id] });
  };
  const resetPasswordHandler = async () => {
    if (validation()) {
      try {
        setButtonLoader(true);
        const res = await resetPasswordApi({
          ...password,
          email: data?.email,
          otp: otp,
        });
        if (res?.data?.status === 200) {
          toastMessage(res?.data?.message, "success", 10000);
          setSteps(1);
          setPassword({});
        } else {
          toastMessage(res?.data?.message, "warning", 10000);
        }
      } catch (e) {
        console.log("error", e);
      } finally {
        setButtonLoader(false);
      }
    }
  };

  // console.log(errors, "errors");
  return (
    <>
      <form>
        <div className="back_button">
          <Link to={-1}>
            <IoIosArrowBack /> Back
          </Link>
        </div>
        <div className="form_title">
          <h2>Reset Pasword</h2>
          <p>
            Please enter a new password below to reset your account password.
            Make sure to choose a strong password that includes a combination of
            letters, numbers, and special characters to keep your account
            secure.
          </p>
        </div>
        <div className="content">
          <div className="form_field has_icon">
            <Input
              type={"number"}
              className={"form-control input"}
              label={"OTP"}
              placeholder={"Enter 4 digit OTP"}
              value={otp}
              onChange={(e) => {
                let value = e.target.value;
                if (/^\d*$/.test(value) && value.length <= 4) {
                  setOtp(value);
                }
              }}
              name={"otp"}
              id={"otp"}
              error={errors?.otp}
            />
          </div>
          <div className="form_field has_icon">
            <Input
              className={"form-control input"}
              value={password.newPassword}
              onChange={onChangeHandler}
              label={"New Password"}
              placeholder={"Enter New Password"}
              name={"newPassword"}
              error={errors?.newPassword}
              extraErr={errors.newPasswordErr}
              type={inputToggle.newPassword ? "password" : "text"}
              onPaste={(e) => {
                e.preventDefault();
                return false;
              }}
              onCopy={(e) => {
                e.preventDefault();
                return false;
              }}
            />
            <span
              className="password_icons"
              onClick={() => toggleInputTypeHandler("newPassword")}
            >
              {inputToggle.newPassword ? <IoEyeOutline /> : <IoEyeOffOutline />}
            </span>
          </div>
          <div className="form_field has_icon">
            <Input
              className={"form-control input"}
              // type={inputToggle.confirmPassword ? "password" : "text"}
              type={"text"}
              value={password.confirmPassword}
              onChange={onChangeHandler}
              label={"Confirm Password"}
              placeholder={"Enter Confirm Password"}
              name={"confirmPassword"}
              error={errors?.confirmPassword}
              extraErr={errors.confirmPasswordErr}
              onPaste={(e) => {
                e.preventDefault();
                return false;
              }}
              onCopy={(e) => {
                e.preventDefault();
                return false;
              }}
            />
            {/* <span
                    className="password_icons"
                    onClick={() => toggleInputTypeHandler("confirmPassword")}
                  >
                    {inputToggle.confirmPassword ? (
                      <IoEyeOutline />
                    ) : (
                      <IoEyeOffOutline />
                    )}
                  </span> */}
          </div>
          <div className="button_wrap">
            <button
              type="button"
              ref={buttonLoader}
              className="button"
              onClick={resetPasswordHandler}
            >
              Reset
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default ResetPassword;
